import { type RetrieveUserData, getUserById, updateUser } from '~/api'
import {
  getPermissionsPerRole,
  objectToPermissionList,
  permissionListToObject,
} from '~/utils/permissions-utils'

export async function getUserToBeEdited(userId: number) {
  const response = await getUserById(userId)
  let retrievedUser = response.data.data.retrieveUser

  const permissions = Array.isArray(retrievedUser.permissions)
    ? permissionListToObject(retrievedUser.permissions)
    : getPermissionsPerRole({
        ...retrievedUser,
        // @ts-expect-error hubModel probably only has partial data
        hub: retrievedUser.hubModel,
        // @ts-expect-error organizationModel probably only has partial data
        organization: retrievedUser.organizationModel,
      })

  retrievedUser = {
    ...retrievedUser,
    hub: retrievedUser.hubModel,
    organization: retrievedUser.organizationModel,
    // @ts-expect-error the type of `permissions` is `{}` not `Permission[]`
    permissions,
  }

  return retrievedUser
}

export async function updateUserPermissions(
  userToEdit: RetrieveUserData | null,
) {
  if (!userToEdit) throw new Error('No user to edit')

  const permissionsObject = Array.isArray(userToEdit.permissions)
    ? permissionListToObject(userToEdit.permissions)
    : userToEdit.permissions

  const permissionsList = objectToPermissionList(permissionsObject)
  const values = { ...userToEdit, permissions: permissionsList }

  return await updateUser(values)
}
